import * as Yup from "yup";

export const modifierItemSchema = Yup.object({
  name: Yup.string().trim().required("Modifier item name is required"),
  nonEnglishName: Yup.string().nullable(),
    taxRate: Yup.number()
    .typeError("Tax rate must be a number")
    .min(0, "Tax rate cannot be negative")
    .max(1, "Tax rate must be between 0 and 1")
    .test(
      "max-decimals",
      "Tax rate cannot have more than 4 decimal places",
      (taxRate) => {
        if (taxRate === undefined || taxRate === null) return true;
        return /^(0(\.\d{1,4})?|1(\.0{1,4})?)$/.test(String(taxRate));
      }
    ),

  modifierItemOptionInputList: Yup.array()
    .of(
      Yup.object({
        name: Yup.string().trim(),
        nonEnglishName: Yup.string().nullable(),

        priceCents: Yup.number()
          .typeError("Price must be a number")
          .min(0, "Price cannot be negative"),

        renderSequence: Yup.number()
          .typeError("Render sequence must be a number")
          .integer("Render sequence must be an integer")
          .min(0, "Render sequence cannot be negative"),
      })
    )
    .optional(),
});